export default "__VITE_ASSET__BSUqtjdy__"